// extracted by mini-css-extract-plugin
export default {"modalOverlay":"tz-z","modalContent":"uz-z","header":"vz-z","close":"wz-z"};